function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 17a1 1 0 01-1 1H6a1 1 0 110-2h20a1 1 0 011 1zM27 10a1 1 0 01-1 1H6a1 1 0 110-2h20a1 1 0 011 1zM17 24a1 1 0 01-1 1H6a1 1 0 110-2h10a1 1 0 011 1z",
  fill: "#80E0A7"
});

function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), _ref);
}

export default SvgIconMenu;